import { useEffect } from "react";

const useOnMount = onMount =>
    useEffect(() => {
        onMount && onMount();
        // eslint-disable-next-line
    }, []);

export default useOnMount;